import * as React from "react";
import { Props } from "../../types/global";
import { AuthService } from "./auth-service";
import PubSub from 'pubsub-js';
import { dialogService } from "react-api-dialog";
import { Social } from "./Social";
import { messageDialog } from "../dialogs/MessageDialog";
import { AuthHeader } from "./AuthHeader";
import { Form, FormRef } from "@ajayvikas/react-fluent-validation";
import { Input } from "../Controls/Input";
import { registerValidator } from "./validators";
import t from "../i18n";
import { LoginWithAnalytics, VerifyWithAnalytics } from ".";
import { btnStyles } from "../_styles/button";
import { css } from "emotion";
import classNames from "classnames";

declare type RegisterState = {
    email: string,
    password: string,
    confirmPassword: string,
    rememberMe: boolean,
}
export default class Register extends React.Component<Props, RegisterState> {
    readonly state: RegisterState = {} as RegisterState;
    form: FormRef | null;
    assignFormRef = (form: FormRef | null) => {
        this.form = form;
    }
    showMessage = (message: string, title: string) => {
        if (this.props.ok) {
            alert(message);
        } else {
            messageDialog(message, title);
        }
    }
    showLogin = () => {
        if (this.props.ok) {
            dialogService.replaceComponent(LoginWithAnalytics, "/login");
        } else {
            this.props.history.push("/login");
        }
    }
    showVerify = () => {
        if (this.props.ok) {
            dialogService.replaceComponent(VerifyWithAnalytics, "/verify");
        } else {
            this.props.history.push("/verify");
        }
    }
    onRegister = async () => {
        if (!this.form) return;
        const validationResult = this.form.submit();
        const isValid = validationResult?.isValid() ?? false;
        if (isValid === false) {
            this.showMessage(t.error("validation_error"), t.menu("register"));
            return;
        }
        dialogService.showPreloader();
        const { email, password, confirmPassword } = this.state;
        const response = await AuthService.register(email, password, confirmPassword);
        await dialogService.hidePreloader();
        if (response.succeeded === true) {
            localStorage.setItem("un", this.state.email);
            this.showVerify();
        } else {
            let message: string = "";
            switch (response.statusCode) {
                case "InvalidEmail":
                case "InvalidUserName":
                    message = t.validations("invalid_user_name");
                    break;
                case "DuplicateEmail":
                case "DuplicateUserName":
                    message = t.validations("username_already_taken");
                    break;
                case "PasswordTooShort":
                    message = t.validations("password_char_length");
                    break;
                case "PasswordRequiresNonAlphanumeric":
                    message = t.validations("password_char_type");
                    break;
                case "PasswordRequiresDigit":
                    message = t.validations("pass_rule_4");
                    break;
                case "PasswordRequiresLower":
                    message = t.validations("pass_rule_2");
                    break;
                case "PasswordRequiresUpper":
                    message = t.validations("pass_rule_3");
                    break;
                case "error":
                default:
                    message = t.error("registration_problem");
                    break;
            }
            this.showMessage(message, t.menu("register"));
        }
    }
    onCancel = () => {
        if (this.props.cancel) this.props.cancel();
        else (this.props.history.goBack())
    }
    onLoginSuccess = () => {
        PubSub.publish("AUTH", "LOGIN");
        if (this.props.ok) this.props.ok(true);
        else this.props.history.replace("/topup");
    }
    render() {
        return (
            <div className="auth container small-gutter">
                <div className="auth-box">
                    <Form ref={this.assignFormRef} object={this.state} validator={registerValidator} autoComplete="off">
                        <AuthHeader text={t.menu("register")} showLogo={!!this.props.ok} />
                        <Social onLoginSuccess={this.onLoginSuccess} />
                        <div className="form-group relative">
                            <h5>{t.topup("user_name_label")}</h5>
                            <Input type="text" className="form-control" propertyName="email"
                                value={this.state.email || ""} onChange={e => this.setState({ email: e.target.value })} />
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group relative">
                                    <h5>{t.topup("password_label")}</h5>
                                    <div style={{ fontSize: 12, marginBottom: 5 }}>{t.validations("password_message")}</div>
                                    <input style={{ display: "none" }} type="password" name="fakepasswordremembered" />
                                    <div style={{position: "relative"}}>
                                        <Input type="password" className="form-control" propertyName="password" top={11} autoComplete="off"
                                            value={this.state.password || ""} onChange={e => this.setState({ password: e.target.value })} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group relative">
                                    <h5 style={confirmPasswordStyle}>{t.topup("confirm_password_label")}</h5>
                                    <Input type="password" className="form-control" propertyName="confirmPassword"
                                        value={this.state.confirmPassword || ""} onChange={e => this.setState({ confirmPassword: e.target.value })} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group text-right">
                            <a className="button white text-center login-cancel-btn" onClick={this.onCancel}>{t.common("cancel_button")}</a>
                            <a className={classNames(['button', css(btnStyles.default), 'text-center'])} onClick={this.onRegister}>{t.menu("register")}</a>
                        </div>
                        <div>
                            <a href="javascript:void(0)" onClick={this.showLogin}>{t.login("link_login")}</a>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}
const confirmPasswordStyle: React.CSSProperties = {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
}